(ns kyber.components.composite.checkbox
  (:require [reagent.core :as reagent]

            [kyber.components.base.icons :as icons]
            [kyber.components.base.text :as text]
            [kyber.styles.core :refer [gs styles->classes]]))

(def classes
  (styles->classes
   {:input-container
    {:position :relative
     :width "20px"
     :height "20px"
     :display :inline-block
     :margin-right (gs [:spacing :p8])
     :border (str "1px solid " (gs [:colors :gray-scale-600]))
     :padding (gs [:spacing :p0])
     :float :left}

    :checkbox
    {:display :none}

    :checkmark
    {:width "20px"
     :position :absolute
     :top "3px"
     :left "4px"
     :color (gs [:colors :primary-lite-800])
     :z-index 1
     :cursor :pointer}

    :custom-checkbox
    {:width "18px"
     :height "18px"
     :position :absolute
     :cursor :pointer
     :border (str "1px solid " (gs [:colors :true-white]))
     :user-select :none
     :background :transparent
     "&:focus" {:outline (gs [:spacing :p0])
                :border-image :none}}

    :v2-container
    {:display :flex
     :align-items :center}

    :v2-check
    {:position :absolute
     :left (gs [:spacing :p2])
     :bottom (gs [:spacing :p2])}

    :v2-check-disabled
    {:color (gs [:colors :gray-scale-400])}

    :v2-label
    {:margin (gs [:spacing :p0])
     :margin-left (gs [:spacing :p8])
     :cursor :pointer}

    :v2-button-container
    {:position :relative
     :width (gs [:spacing :p20])
     :height (gs [:spacing :p20])
     :border (str "1px solid " (gs [:colors :gray-scale-300]))
     :background (gs [:colors :true-white])
     :outline :none
     :cursor :pointer
     :border-radius (gs [:radius :r3])

     "&:disabled"
     {:background-color (gs [:colors :gray-scale-100])}}}))

(defn render-v2
  [{:keys [default-value label on-change]
    :or {default-value false
         on-change identity}}]
  (let [checked (reagent/atom default-value)
        !ref (atom nil)]
    (fn [{:keys [disabled]
          :or {disabled false}}]
      [:div {:class (:v2-container classes)}
       [:button {:class (:v2-button-container classes)
                 :disabled disabled
                 :data-test "boost-resource-selection-button"
                 :role "checkbox"
                 :aria-checked (str @checked)
                 :aria-label (or label "Checkbox")
                 :on-click #(do
                              (.preventDefault %)
                              (swap! checked not)
                              (on-change @checked))
                 :id label
                 :type :button
                 :ref #(reset! !ref %)}
        (when (true? @checked)
          [icons/icon {:class (cond-> (:v2-check classes)
                                (true? disabled)
                                (str " " (:v2-check-disabled classes)))}
           :check])]

       (when (some? label)
         [text/caption-20 :p
          {:class (:v2-label classes)
           :on-click #(js-invoke @!ref "click")}
          label])])))

(defn render
  {:doc "Checkbox"
   :id :checkbox
   :version 0
   :variant :a}
  [{:keys [name value selected on-click style]
    :or {on-click identity}}]
  (let [!ref (atom nil)
        click-fn (fn [e]
                   (.preventDefault e)

                   (.click @!ref))]
    [:div (cond-> {:class (:input-container classes)}
            (some? style)
            (assoc :style style))
     (when selected
       [icons/icon-sm
        {:class (:checkmark classes)
         :on-click click-fn}
        :check])

     [:button {:class [(:custom-checkbox classes)]
               :role "checkbox"
               :aria-checked (str (boolean selected))
               :aria-label (or name "Checkbox")
               :on-click click-fn}]
     [:input {:type :checkbox
              :name name
              :id name
              :value (or value "")
              :class (:checkbox classes)
              :ref #(reset! !ref %)
              :on-click #(on-click @!ref)}]]))
